import React from 'react'
import styles from './Alert.module.scss'

const Alert = ({type, children}) => <div className={styles[type]}>{children}</div>

export default Alert